import { Stack } from '@mantine/core'
import { useGetLoraDevice } from 'api/loraDevices'
import { Query } from 'components/common'
import { useParams } from 'react-router-dom'
import { TLoraDevice } from 'shared/types'
import { DeviceKeys } from './DeviceKeys'

export const LoraDeviceKeys = () => {
  const { deviceId } = useParams()
  const query = useGetLoraDevice(deviceId)

  if (!deviceId) throw new Error('Missing deviceId')

  return (
    <Query.Wrapper query={query}>
      <Query.Data>
        {(data: TLoraDevice) => (
          <Stack gap={'xl'}>
            <DeviceKeys keys={data} />
          </Stack>
        )}
      </Query.Data>
    </Query.Wrapper>
  )
}
